/**
 * Service pour gérer les référents et leurs informations Telegram
 */

// URL de l'API
const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin + '/api';
  }
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

/**
 * Récupère l'ID Telegram d'un référent
 * @param {string} referentName - Nom du référent (MEHDI, SARAH, etc.)
 * @returns {Promise<object>} - ID Telegram du référent
 */
export const getReferentTelegramId = async (referentName) => {
  try {
    console.log('📱 Récupération du Telegram ID pour:', referentName);

    const response = await fetch(`${API_BASE_URL}/referents/getTelegramId`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ referentName }),
    });

    if (!response.ok) {
      console.log('⚠️ Référent non trouvé ou Telegram ID manquant');
      return null;
    }

    const result = await response.json();

    if (result.success && result.telegram_id) {
      console.log('✅ Telegram ID récupéré:', result.telegram_id);
      return result.telegram_id;
    }

    return null;
  } catch (error) {
    console.error('❌ Erreur lors de la récupération du Telegram ID:', error);
    return null;
  }
};

/**
 * Mapping des référents et leurs IDs Telegram (fallback)
 */
export const REFERENTS_TELEGRAM = {
  MEHDI: '@HOUSSEMEDDINEMTIR',
  SARAH: '@id8097750927',
};

/**
 * Récupère l'ID Telegram d'un référent avec fallback
 * @param {string} referentName - Nom du référent
 * @returns {Promise<string>} - ID Telegram
 */
export const getTelegramId = async (referentName) => {
  if (!referentName) {
    console.log('⚠️ Pas de référent défini, utilisation de MEHDI par défaut');
    return REFERENTS_TELEGRAM.MEHDI;
  }

  // Essayer d'abord l'API
  const telegramId = await getReferentTelegramId(referentName);

  if (telegramId) {
    return telegramId;
  }

  // Fallback sur le mapping local
  const upperName = referentName.toUpperCase();
  if (REFERENTS_TELEGRAM[upperName]) {
    console.log('📋 Utilisation du mapping local pour:', upperName);
    return REFERENTS_TELEGRAM[upperName];
  }

  // Si rien n'est trouvé, utiliser MEHDI par défaut
  console.log('⚠️ Référent inconnu, utilisation de MEHDI par défaut');
  return REFERENTS_TELEGRAM.MEHDI;
};

export default {
  getReferentTelegramId,
  getTelegramId,
  REFERENTS_TELEGRAM,
};
